import { render, staticRenderFns } from "./UWCard.vue?vue&type=template&id=c06a2116&"
import script from "./UWCard.vue?vue&type=script&lang=js&"
export * from "./UWCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports